import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

function MobileVerification() {
  return (
    <>
      <Navbar />
      <div className="login-div">
        <div className="login-form">
          <div className="login-form-left">
          </div>
          <div className="login-form-right">
            <p>Welcome to <span>Hostess</span></p>
            <br />
            <h3>Mobile Phone Verification</h3>
            <br />
            <h5>The OTP has been via to your mobile phone : +394596458963</h5>
            <br />

            <br />
            <label>Verification Code</label>
            <input placeholder="Enter Code" />
            <br />

            <div className="forget">
              <br />

              <h6>1 Min 57 Secs Resend OTP</h6>
              <br />
              <br />
              <br />
              <Link to='/addabout'>

                <button>Verify the Code</button>
              </Link>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default MobileVerification